import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

export default function CallbackActivacion() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [estado, setEstado] = useState('procesando');

  useEffect(() => {
    const call = searchParams.get('call');
    if (call) {
      axios.post('https://l0sqt7a9v0.execute-api.us-east-1.amazonaws.com/prod/callback', { call })
        .then(() => setEstado('exito'))
        .catch(() => setEstado('exito'));
    } else {
      setEstado('exito');
    }
  }, [searchParams]);

  return (
    <div style={{
      minHeight: '80vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 20,
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 20,
        padding: '40px 24px',
        textAlign: 'center',
        maxWidth: 400,
        width: '100%',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      }}>
        {estado === 'procesando' ? (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>⏳</div>
            <h2 style={{ color: '#1a3a2a', marginBottom: 8 }}>Procesando...</h2>
            <p style={{ color: '#6b8f71', fontSize: 14 }}>Confirmando tu activación</p>
          </>
        ) : (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <h2 style={{ color: '#1a3a2a', marginBottom: 8 }}>¡Activación en Proceso!</h2>
            <p style={{ color: '#6b8f71', fontSize: 14, marginBottom: 16 }}>
              Tu línea estará lista en unos minutos. Recuerda registrar tu IMEI.
            </p>
            <a
              href="https://rnu.altanredes.com/addomv/vinculatulinea"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                padding: '14px 32px',
                background: '#2d6a4f',
                color: '#fff',
                border: 'none',
                borderRadius: 12,
                fontSize: 15,
                fontWeight: 700,
                cursor: 'pointer',
                textDecoration: 'none',
                marginBottom: 12,
              }}
            >
              Registrar IMEI en Altán
            </a>
            <br />
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                padding: '12px 28px',
                background: '#1a3a2a',
                color: '#fff',
                border: 'none',
                borderRadius: 12,
                fontSize: 14,
                fontWeight: 700,
                cursor: 'pointer',
                marginTop: 8,
              }}
            >
              Ir a mi Panel
            </button>
          </>
        )}
      </div>
    </div>
  );
}
